import classNames from 'classnames'
import Link from '@/components/Common/Link'
import Text from '@/stories/components/Common/NewText'

export default function CorporateAnnouncements(props) {
  const {
    heading,
    list,
    company_name,
    containerClassName = '',
    headingClassName = '',
    subheading = '',
  } = props

  if (!(heading && list.length)) {
    return null
  }

  return (
    <div
      className={classNames(
        'bg-brand-white rounded-xl p-6 pb-6',
        containerClassName,
      )}
    >
      <div className={classNames('flex flex-col gap-1', headingClassName)}>
        <h2 className="text-brand-black text-xl font-medium lg:text-2xl">
          {company_name} {heading}
        </h2>
        {subheading && (
          <Text appearance="caption" addClassName="text-brand-grey-base">
            {subheading}
          </Text>
        )}
      </div>

      <ul className="mt-2">
        {list?.map((el, idx) => {
          return (
            <li
              key={el.title}
              className={classNames('py-4', {
                'border-brand-tertiary-grey border-b-2':
                  list.length - 1 !== idx,
              })}
            >
              <h3 className="font-medium">{el.title}</h3>
              <p className="text-brand-grey-base text-sm">{el.subtitle}</p>

              {!!(el.relative_cta_link || el.link) && (
                <Link
                  href={el.relative_cta_link ?? el.link}
                  className="text-brand-blue-azureRadiance mt-2 inline-block text-sm"
                  title={el?.read_more ? el?.read_more : 'Read More'}
                >
                  {el?.read_more ? el?.read_more : 'Read More'}
                </Link>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
